import { Button, Dialog, Grid, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/styles';
import React, { useState, useEffect, useContext } from 'react';
import { poppins400, poppins500 } from 'theme/common.style';
import { useHistory, useLocation } from 'react-router-dom';
import { getApiCall } from 'api/apiService';
import { GET_DEPOSIT } from 'constant/app.config';
import DepositPaymentDetailsNew from 'component/BuyerRegistration/components/DepositPaymentDetailsNew';
import { datacontext } from 'modules/AppLayout/AppLayout';

const LockSign = () => {
  return (
    <svg
      width="105"
      height="125"
      viewBox="0 0 105 125"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.91171 96.6663C5.45725 110.301 16.9877 120.933 30.7016 121.419C37.6581 121.665 44.8012 121.794 52.4998 121.794C60.1984 121.794 67.3414 121.665 74.298 121.419C88.0121 120.933 99.5423 110.301 101.088 96.6663C101.627 91.9133 102 87.0844 102 82.1935C102 77.3025 101.627 72.4738 101.088 67.7213C99.5423 54.086 88.0121 43.4548 74.298 42.9681C67.3414 42.7213 60.1984 42.5938 52.4998 42.5938C44.8012 42.5938 37.6581 42.7213 30.7016 42.9681C16.9876 43.4548 5.45725 54.086 3.91171 67.7213C3.37293 72.4738 3 77.3025 3 82.1935C3 87.0844 3.37293 91.9133 3.91171 96.6663Z"
        fill="#F93939"
        fill-opacity="0.1"
        stroke="#F93939"
        stroke-width="5"
      />
      <path
        d="M80.1897 42.5999V30.7199C80.1897 23.3681 77.2692 16.3174 72.0709 11.1189C66.8723 5.92047 59.8217 3 52.4699 3C45.1181 3 38.0675 5.92047 32.869 11.1189C27.6705 16.3174 24.75 23.3681 24.75 30.7199V42.5999"
        stroke="#F93939"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M52.5206 94.0861C59.0817 94.0861 64.4005 88.7672 64.4005 82.2061C64.4005 75.645 59.0817 70.3262 52.5206 70.3262C45.9595 70.3262 40.6406 75.645 40.6406 82.2061C40.6406 88.7672 45.9595 94.0861 52.5206 94.0861Z"
        fill="#F93939"
      />
    </svg>
  );
};

const WarningIconRED = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4901 11.4607L11.5789 1.45599C11.0462 0.555115 10.0621 0 8.99672 0C7.9314 0 6.94728 0.555115 6.41462 1.45599L0.399495 11.632C-0.133165 12.5329 -0.133165 13.6431 0.399495 14.544C0.932154 15.4449 1.91628 16 2.9816 16H15.0119C15.0152 16 15.0184 16 15.0184 16C16.6651 16 18 14.6962 18 13.088C18 12.4853 17.8116 11.9239 17.4901 11.4607ZM10.2732 12.4345C10.2732 13.1229 9.73078 13.6495 9 13.6495C8.26922 13.6495 7.72681 13.1229 7.72681 12.4345V12.406C7.72681 11.7208 8.26922 11.1911 9 11.1911C9.73078 11.1911 10.2732 11.7177 10.2732 12.406V12.4345ZM10.3024 4.24425L9.67232 9.61776C9.6301 10.0048 9.36702 10.2458 9 10.2458C8.63298 10.2458 8.3699 10.0016 8.32768 9.61776L7.69758 4.24108C7.65536 3.82554 7.88599 3.5115 8.28221 3.5115H9.71454C10.1108 3.51467 10.3446 3.82871 10.3024 4.24425Z"
        fill="#FF3B30"
      />
    </svg>
  );
};

const DepositOverdueRestrictedPopup = ({
  open,
  streetName,
  propertyId,
  individualPage,
  getBuyerIndividualValue,
  binderId,
  setPaymentPop,
  flagSign,
  flagSignStatus,
  onClose,
  setShowActivateTrade,
}) => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const isXsScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const { setShowMessage, setMessagedata } = useContext(datacontext);

  const [depositeopen, setDepositeopen] = React.useState(false);
  const [getDeposit, setGetDeposit] = useState();
  const GetDeposit = () => {
    let accesstoken = 'Bearer ' + localStorage.getItem('accesstoken');
    getApiCall(`${GET_DEPOSIT.replace(/\/$/, '')}/${propertyId}`, {
      method: 'GET',
      headers: {
        Authorization: accesstoken,
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      setGetDeposit(res?.data);
      setDepositeopen(true);
    });
  };
  const history = useHistory();

  const handleDepositPaymentClick = () => {
    if (!individualPage) {
      history.push({
        pathname: `market/${propertyId}`,
        state: { triggerGetDeposit: true },
      });
    } else {
      setShowActivateTrade(true);
      GetDeposit();
    }
  };

  const handleContactAgent = () => {
    setShowMessage(true);
    setMessagedata({ binderId: binderId });
  };

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            maxWidth: '721px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '30px',
            pointerEvents: 'auto',
          },
        }}
        sx={{
          pointerEvents: 'none',
          alignItems: 'flex-start',
          mt: '100px',
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: 'rgba(0,0,0,0.5)',
              position: 'absolute',
              top: '-50px',
              pointerEvents: 'auto',
            },
          },
          paper: {
            sx: {
              pointerEvents: 'auto',
            },
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid
            item
            xs={12}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <LockSign />
            <Typography
              sx={{ ...poppins500, fontSize: '24px', lineHeight: '39px' }}
            >
              Account Restricted
            </Typography>
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '18px' : '24px',
                lineHeight: '39px',
              }}
            >
              Deposit Payment - OVERDUE
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              sx={{ ...poppins400, fontSize: '16px', color: '#666666' }}
            >
              You have an OVERDUE deposit payment for{' '}
              <span>
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 550,
                    color: '#666666',
                  }}
                >
                  {streetName}
                </b>
              </span>
              . Please process this payment immediately as you are now in
              default of your deposit payment obligations.
            </Typography>
          </Grid>
          <Grid
            item
            container
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              border: '1px solid',
              borderColor: '#FF3B30',
              bgcolor: 'rgba(249, 57, 57, 0.1)',
              padding: 2,
              mt: '30px',
              alignItems: 'center',
              mr: '-30px',
            }}
          >
            <Grid item xs={1} sx={{ display: 'flex', alignItems: 'center' }}>
              <WarningIconRED fontSize={isXsScreen ? 'small' : 'medium'} />
            </Grid>
            <Grid item xs={10}>
              <Typography
                sx={{ ...poppins400, color: '#666666', fontSize: '16px' }}
              >
                Your account has been restricted and you remain at risk of being
                permanently barred.
                <br />
                <br />
                Please process your deposit payment immediately to avoid further
                action.
              </Typography>
            </Grid>
          </Grid>

          <Grid
            item
            container
            direction="row"
            sx={{ display: 'flex', alignItems: 'center' }}
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? '15px' : 5}
          >
            <Grid item>
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={handleContactAgent}
              >
                Contact Agent
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                  cursor: 'pointer',
                }}
                onClick={handleDepositPaymentClick}
              >
                Deposit Payment
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
      <DepositPaymentDetailsNew
        open={depositeopen}
        setDepositeopen={setDepositeopen}
        data={getDeposit}
        getBuyerIndividualValue={getBuyerIndividualValue}
        setPaymentPop={setPaymentPop}
      />
    </>
  );
};

export default DepositOverdueRestrictedPopup;
